/**
 * Deprecated at 2.0.0. Use SpinnerSize instead.
 * @deprecated
 */
export enum SpinnerType {
  normal = 0,
  large = 1
}

export enum SpinnerSize {
  xSmall = 0,
  small = 1,
  medium = 2,
  large = 3
}